import React, { Fragment } from 'react';
import { useState, useEffect, useRef } from 'react';
import useLoader from "../../hooks/useLoader";
import { useMsal } from "@azure/msal-react";
import classes from "./AssignBulkPopup.module.css";
import { useMemo } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { Alert, Autocomplete, CircularProgress } from '@mui/material';
import { Box, FormControl, FormHelperText, Grid, Grid2, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography, Button, styled } from '@mui/material';
import { KeyboardDoubleArrowRight } from '@mui/icons-material';
import axios from 'axios';
import { getToken, getMSID } from "../../authfile";
import SnackBar from '../UI/SnackBar';
import { useBulkAssignCases } from '../../queries/useBulkAssignCases';
import Loader from '../UI/Loader';
import { useSnackbar } from 'notistack';
import WithConditional from '../hoc/WithConditional';
import zIndex from '@mui/material/styles/zIndex';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'left',
  boxShadow: '0px !important',
  border: 'none',
  //boxShadow:' 0px 0px 4px rgba(0, 0, 0, 0.1), 0px 0px 5px rgba(0, 0, 0, 0.07), 0px 0px 10px rgba(0, 0, 0, 0.06)',
  color: theme.palette.text.secondary,
  margin: '1rem',
  padding: '1rem'
}));


const DropDownComponent = ({
  fieldItem,
  fieldValue,
  error,
  Validations,
  setError,
  handleChange,
  options
}) => (
  <Grid2 size={3}>
    <Stack
      alignItems="start"
      spacing={1}
    >
      <label style={{ fontWeight: 'bold' }} title={fieldItem.length > 80 && fieldItem}>{fieldItem.substr(0, 80) + (fieldItem.length > 80 ? "..." : "")}</label>
      {/* <FormControl  variant="outlined" size="small" sx={{ width: '100%' }} error={error ? true : false}> */}
      {/* <InputLabel sx={{display:'none'}}  id="demo-simple-select-error-label">{fieldItem+(fieldItem.length>80 ? "..." : "")}</InputLabel>  */}
      <Select
        labelId="demo-simple-select-error-label"
        id="demo-simple-select-error"
        //label={fieldItem}
        sx={{
          height: '30px !important',
          '& .MuiSelect-select': {
            fontSize: '13px !important'
          }
        }}
        value={fieldValue}
        onChange={(e) => handleChange(e)}
        fullWidth
      >
        <MenuItem value="Select Order" selected disabled>Select Order</MenuItem>
        {options?.map((eachValue) => (
          <MenuItem value={eachValue.value}>{eachValue.label}</MenuItem>
        ))}
      </Select>
      {/* <FormHelperText>{error}</FormHelperText>
      </FormControl> */}
    </Stack>
  </Grid2>
);

const TextFieldComponent = ({
  fieldItem,
  fieldValue,
  error,
  setError,
  Validations,
  handleChange
}) => (
  <Grid2 size={4}>
    <Stack
      alignItems="start"
      spacing={1}
    >
      <label style={{ fontWeight: 'bold' }}>{fieldItem}<sup style={{ color: 'red'}}>  *</sup></label>
      <TextField
        sx={{ m: 0 }}
        aria-labelledby="its-the-label"
        error={error ? true : false}
        id="filled-error-helper-text"
        value={fieldValue}
        helperText={error}
        placeholder={fieldItem}
        onChange={(e) => handleChange(e)}
        size="small"
        fullWidth
        
        type="number"
        inputProps={{
          min: 0,
          step: 1,
          pattern: "[0-9]*"
        }}
        onKeyDown={(e) => {
          if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
            e.preventDefault();
          }
        }}


        InputProps={{
          sx: {
            height: '30px !important',
          },
        }}
      />
    </Stack>

  </Grid2>
);

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80%',
  bgcolor: 'background.paper',
  border: '0.2rem solid #002277',
  boxShadow: 24,
  px: 3,
  zIndex:998,
  overflow: 'auto',
};

const AssignBulkPopup = ({ open, userList, reportName, cases, closePopup, isFiltered }) => {
  const tokenConfig = {
    headers: {
        "Authorization": `Bearer ${getToken()}`,
    },
  };
  const [editedUsers, setEditedUsers] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [loader, showLoader, hideLoader] = useLoader();
  const { instance, inProgress, accounts } = useMsal();
  const [selectedUserValue, setSelectedUserValue] = useState("Select Order");
  const [userValue, setUserValue] = useState("Select User");
  const [userCount, setUserCount] = useState();
  const [paNumbersString, setPaNumbersString] = useState("");
  const [userListString, setUserListString] = useState("");
  const [countString, setCountString] = useState("");
  const ascDescOption = [
    { value: 'Asc', label: 'Asc' },
    { value: 'Desc', label: 'Desc' }
  ]
  const alertRef = useRef();
  const [data, setData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync: assignCases, isLoading: isUpdatingCases } =
    useBulkAssignCases({ reportName });

  useEffect(() => {
    
    let countString = "";
    let userString = "";
    if (data.length !== 0)
      data.forEach((item) => {
        countString += item.Count + ",";
        userString += item.User.split('/')[1] + ",";
      })
    countString = (countString !== "") ? countString.slice(0, -1) : countString;
    userString = (userString !== "") ? userString.slice(0, -1) : userString;

    setCountString(countString);
    setUserListString(userString);
  }, [data])


  useEffect(() => {

    let paNumbersString = "";
    // cases=cases.sort((a,b)=>{
    //   const date1=a.original.SLA_COMPLIANCE || a.original.LOAD_DATE;
    //   const date2=b.original.SLA_COMPLIANCE || b.original.LOAD_DATE;
    //   return new Date(date1) - new Date(date2);
    // })
    if (cases !== "")
      cases.forEach((item) => {
        paNumbersString += item.original.CASE_ID + ",";
      })

    paNumbersString = (paNumbersString !== "") ? paNumbersString.slice(0, -1) : paNumbersString;
    setPaNumbersString(paNumbersString);
  }, [cases])

  const hideSnackBar = () => {
    alertRef.current.handleClose();
  }

  const submitAssignedCases = async (selectedRows) => {
    try {
      let count = 0;
      data.forEach((item) => {
        count += Number(item.Count)
      })

      let paNumbersLimitedToCount = "";
      paNumbersString.split(',').forEach((item, index) => {
        if (index < count) {
          paNumbersLimitedToCount = paNumbersLimitedToCount + item + ','
        }
        else {
          return;
        }
      })
      paNumbersLimitedToCount = paNumbersLimitedToCount.slice(0, -1);

      const jsonData = {
        "report": reportName,
        "caseId": isFiltered ? paNumbersString : "",
        "user": userListString,
        "countCasePerUser": countString,
        "updatedBy": getMSID()
      }
      const config = {
        headers: {
          ...tokenConfig['headers'],
          "Content-Type": "application/json"
        },
      };

      const response = assignCases({body: jsonData, config: config});
      response.then((res) => {
        if (res === 1) {
          enqueueSnackbar("Bulk Assignment is successful", {
            variant: 'success'
          })
          closePopup();
        } else {
           throw new Error(res.message)
        }
      }).catch((err) => {
        enqueueSnackbar(`something went wrong, ${err.message}`, {
          variant: 'error'
        })
      })
    }
    catch (error) {
      enqueueSnackbar("Something Went Wrong In Assigning Cases", {
        variant: 'error'
      })
    }
  }


  const handleUserChange = (event) => {
    
    setSelectedUserValue(event.target.value);
  }

  const calculateTotalUsers = () => {
    let count = Number(userCount);
    data.forEach((item) => {
      count += Number(item.Count)

    })
  }

  const handleChangeCount = (event) => {
    
    setUserCount(event.target.value);
  }

  const handleAddRow = (event) => {

    event.stopPropagation()

    let count = Number(userCount);
  
    const isCountValid = typeof userCount === 'string' && userCount.trim() !== '' && !isNaN(count) && count >= 0;

    const isUserValid = typeof userValue === 'string' && userValue.trim() !== '' && userValue !== 'Select User';

    if (!isCountValid) {
      enqueueSnackbar('Count is mandatory field, it should be numeric', {
        variant: 'error'
      })
    }

    if (!isUserValid) {
      enqueueSnackbar('User selection is required', {
        variant: 'error'
      })
    }

    if (!isCountValid || !isUserValid) {
      return; 
    }

    let userPresent = false;
    data.forEach((item) => {
      count += Number(item.Count)
      if (item.User === userValue) {
        userPresent = true;
      }
    })

    if (count > cases.length || userPresent) {
      if (count > cases.length)
        enqueueSnackbar("Sum of count of all users cannot exceed total count", {
          variant: 'error'
        })
      else if (userPresent)
        enqueueSnackbar("This user has already been assigned cases", {
          variant: 'error'
        })

      return;
    }
    const newObj = {
      Id: data.length + 1,
      User: userValue,
      Count: userCount,
    }
    setData(prev =>
      [...prev, newObj]);
  }

  const handleDeleteRow = (row) => {
   
    const updatedArray = [];
    
    setData(prev =>
      prev.filter(item => item.User !== row.User));
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'User',
        header: 'User',
        size: 30,
        muiEditTextFieldProps: ({ row }) => ({
          select: true,
          error: !!validationErrors?.user,
          helperText: validationErrors?.user,
        }),

        muiTableHeadCellProps: ({ row }) => ({
          sx: {
            padding: '7% 7%',
            backgroundColor: '#002677 !important',
            color: 'white',
          },
        }),
        Cell: ({ cell, row }) => {
          return (
            <>
              <span>{cell.getValue()}</span>
              {/* <Autocomplete
                id="disable-clearable"
                disableClearable
                defaultValue={cell.getValue()}
                //defaultValue={cell.getValue()}
                value={row.original.User}
                sx={{
                  display: 'inline-block',
                  '& input': {
                    width: '100px !important',
                    fontSize: '13px !important',
                    padding: '0px !important'
                  },
                  '& MuiAutocomplete-popper': {
                    padding: '100px !important',
                    fontSize: '10px !important',
                    backgroundColor: 'black'
                  },
                }}
                onChange={(event, newValue) => {
                  console.log("row.original is....|||....", row.original);
                  setData(
                    prev => prev.map(item =>
                      item.User === row.original.User ? { ...item, User: newValue } : item
                    )
                  )
                }
                }
                options={userList}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      padding: '0px !important',
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: 'search',
                    }}
                  />
                )}
              /> */}
            </>
          )
        }
      },
      {
        accessorKey: 'Count', //normal accessorKey
        header: 'Count',
        size: 30,
        enableColumnFilters: false,
        Header: ({ column }) => {
         
          return <div style={{ margin: '0%', width: '100%' }} >
            {column.columnDef.header}
          </div>
        },
        muiTableHeadCellProps: ({ row }) => ({
          sx: {
            padding: '7% 5%',
            backgroundColor: '#002677 !important',
            color: 'white',
          },
        }),
        Cell: ({ cell, row }) => {
          return (
            <>
              <div style={{ marginLeft: '15%' }}>
                <span>{cell.getValue()}</span>
                {/* <TextField
                  placeholder="Count"
                  defaultValue={cell.getValue()}
                  value={row.original.Count}
                  sx={{
                    m: 1,
                    display: 'flex',
                    justifyContent: 'center',

                  }}
                  InputProps={{
                    sx: {
                      height: '30px !important',
                      width: '60% !important',

                    },
                  }}
                  aria-labelledby="its-the-label"
                  id="filled-error-helper-text"
                  onChange={(event, newValue) => {

                    setData(
                      prev => prev.map(item =>
                        item.User === row.original.User ? { ...item, Count: event.target.value } : item
                      )
                    )
                  }
                  }
                  size="small"
                  fullWidth
                /> */}
              </div>
            </>
          )
        }
      },
      {
        accessorKey: 'DeleteRow',
        header: 'Delete Row',
        size: 30,
        muiTableHeadCellProps: ({ row }) => ({
          sx: {
            padding: '7% 5%',
            backgroundColor: '#002677 !important',
            color: 'white',
            // textAlign:'center'
            // alignItems:'center',
            //marginLeft:'20% !important',

          },
        }),
        Cell: ({ row }) => (
          <Box
            component="span"
            onClick={() => handleDeleteRow(row.original)}
            sx={(theme) => ({
              display: 'flex',
              backgroundColor: theme.palette.error.main,
              borderRadius: '0.25rem',
              fontWeight: 'bold',
              color: '#fff',
              width: '50% !important',
              p: '2% 20% 2% 20%',
              margin: '0% 0% 0% 10%',
              justifyContent: 'center',
              cursor: 'pointer',
            })}
          >
            Delete
          </Box>
        ),
        enableEditing: false,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableTopToolbar: false,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: false,
    muiTableProps: {
      sx: {
        tableLayout: 'fixed',
      }
    },
    muiTableHeadCellProps: ({ row }) => ({
      sx: {
        backgroundColor: '#002677 !important',
        border: 'none',
        color: 'white',
        //padding: '7% 7%',
        //textAlign:'center'
        // alignItems:'center',
        //marginLeft:'20% !important',

      },
    }),

    muiTableHeadCellContentProps: ({ row }) => ({
      sx: {

        padding: '7% 7%',
      },
    }),

    muiTableBodyCellProps: ({ row }) => {
      return ({
        sx: {
          // backgroundColor: 'white',
          padding: '0.3rem 0.5rem',
          border: 'none',
          fontSize: '0.8rem'
        }
      })
    },
    muiTablePaperProps: {
      sx: {
        // boxShadow:'none',
        //border:'none',
        backgroundColor: 'blue',
      }
    },

    muiBottomToolbarProps: {
      sx: {
        // boxShadow:'none',
        // height:'0px'
        display: 'none',
      }
    }
  });

  return (
    <Fragment>
      <WithConditional when={isUpdatingCases}>
          <Loader message="updating cases"/>
        </WithConditional>
      <div className={classes.modal1} >
        
          {/* <div className={classes.modalContent} onClick={hideSnackBar} > */}
          <div className={classes.modalContent} >
            <div>
              <div style={{ display: 'inline-block', marginLeft: '3.7%' }}>
                <label style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '18px' }}>Bulk Assignment</label>
              </div>
              <div style={{ display: 'inline-block', marginLeft: '72%' }}>
                <label className="cursorPointer" style={{ textAlign: 'center', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { closePopup() }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                  </svg>
                </label>
              </div>
            </div>
            <br></br>
            <Item elevation={0}>
              <Grid2 container rowSpacing={3} columnSpacing={4} sx={{ mb: 5, justifyContent: 'flex-center', color: 'black', fontWeight: 'bold' }}>
                <Grid2 size={8}>
                  Report Name : {reportName}

                </Grid2>


                <Grid2 size={4} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                  Total Filtered Count :  {cases.length}
                </Grid2>
              </Grid2>


              <Grid2 container rowSpacing={3} columnSpacing={4}>

                {/* <DropDownComponent
                fieldItem={"Asc/Desc"}
                values={"Asc/Desc"}
                fieldValue={selectedUserValue}
                options={ascDescOption}
                handleChange={handleUserChange}
              />
           */}
                {/* <DropDownComponent
                fieldItem={"User"}
                values={"User"}
                fieldValue={"User"}
               // handleChange={handleChange}
              />
           */}
                <Grid2 size={4}>
                  <Stack
                    alignItems="start"
                    spacing={1}
                  >
                    <label style={{ fontWeight: 'bold' }} title={"User"}>{"User"}<sup style={{color:'red'}} >*</sup></label>
                    <FormControl size="small" sx={{ width: '100%' }} >
                      {/* <InputLabel id="demo-simple-select-error-label">User</InputLabel>  */}
                      <Autocomplete
                        id="disable-clearable"
                        disableClearable
                        defaultValue={"Select User"}
                        value={userValue}
                        sx={{
                          display: 'inline-block',

                          '& input': {
                            width: '100px !important',
                            fontSize: '13px !important',
                            padding: '0px !important',
                            height: '12px !important'
                          },
                          '& MuiAutocomplete-popper': {
                            padding: '100px !important',
                            fontSize: '10px !important',
                            backgroundColor: 'black',
                            height: '10px !important'
                          },
                        }}
                        onChange={(event, newValue) => {
                          setUserValue(newValue);
                        }
                        }
                        options={userList}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              padding: '0px !important',
                            }}
                            InputProps={{
                              ...params.InputProps,
                              type: 'search',
                            }}
                          />
                        )}
                      />
                    </FormControl>
                  </Stack>
                </Grid2>
                <TextFieldComponent
                  fieldItem={"Count"}
                  fieldValue={userCount}
                  handleChange={handleChangeCount}
                />
                <Grid2 size={4}>
                  <Stack
                    alignItems="start"
                    spacing={1}
                  >
                    <label>&nbsp;</label>
                    <Box
                      component="span"
                      sx={(theme) => ({
                        display: 'flex',
                        backgroundColor: theme.palette.success.dark,
                        borderRadius: '0.25rem',
                        fontWeight: 'bold',
                        color: '#fff',
                        width: '80% !important',
                        p: '0.25rem',
                        justifyContent: 'center',
                        cursor: 'pointer'
                      })}
                      onClick={handleAddRow}
                    >
                      Add Row
                    </Box>
                  </Stack>
                </Grid2>
              </Grid2>
              {(data.length > 0) ?
                <div>
                  <div className={classes.caseAssignTable}>
                    <MaterialReactTable table={table} />
                  </div>
                  <Grid2 container rowSpacing={3} columnSpacing={4} sx={{ mt: 5, justifyContent: 'flex-end' }}>
                    <Grid2 size={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Box
                        component="span"
                        onClick={submitAssignedCases}
                        sx={(theme) => ({
                          display: 'flex',
                          backgroundColor: '#002677 !important',
                          borderRadius: '0.25rem',
                          fontWeight: 'bold',
                          color: '#fff',
                          width: '80% !important',
                          p: '0.5rem ',
                          height: '35px',
                          justifyContent: 'center',
                          cursor: 'pointer'
                        })}
                      >
                        Submit
                      </Box>
                    </Grid2>
                  </Grid2>
                </div> : ""}
            </Item>
          </div>
      </div>
    </Fragment>

  )
}

export default AssignBulkPopup;